var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMir({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 16,
    viewBox: "0 0 57 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.3118 7.23279V15.9999H46.1712V10.8046H51.6786C53.995 10.7883 55.9631 9.3028 56.7082 7.23279H41.3118Z",
    fill: "#37A72E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6638 0.00805664C40.9473 3.58797 44.3327 6.42104 48.4633 6.42104H56.9106C56.9754 6.09634 57.0078 5.75539 57.0078 5.40633C57.0078 2.43525 54.6186 0.0324098 51.6624 0.00805664H40.6638Z",
    fill: "url(#paint0_linear_1137_29262)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4719 6.33175C33.5286 6.23434 33.6177 6.17751 33.7311 6.17751C33.893 6.17751 34.0145 6.3074 34.0226 6.46163V15.9188H38.8821V0.00805664H34.0226C33.4071 0.0324098 32.7106 0.478883 32.4514 1.03901L28.5881 9.35154C28.58 9.38401 28.5638 9.41648 28.5476 9.44895C28.4909 9.53012 28.3937 9.58695 28.2804 9.58695C28.1022 9.58695 27.9564 9.44083 27.9564 9.26224V0.00805664H23.0969V15.9188H27.9564C28.5638 15.8863 29.2441 15.4398 29.5033 14.8878L33.4719 6.3561C33.4638 6.34798 33.4719 6.33987 33.4719 6.33175Z",
    fill: "#37A72E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3298 6.60781L12.4871 15.9188H8.98824L6.15355 6.59969C6.12926 6.45358 5.99967 6.33993 5.83769 6.33993C5.65951 6.33993 5.52182 6.48605 5.52182 6.65652V15.9107H0.662354V0H4.8334H6.07256C6.96346 0 7.90296 0.698123 8.16213 1.55048L10.5271 9.30289C10.6486 9.69254 10.8348 9.68442 10.9563 9.30289L13.3213 1.55048C13.5804 0.690005 14.5199 0 15.4108 0H16.65H20.821V15.9107H15.9616V6.65652C15.9616 6.65652 15.9616 6.65652 15.9616 6.6484C15.9616 6.46981 15.8158 6.33181 15.6457 6.33181C15.4837 6.33993 15.3541 6.45358 15.3298 6.60781Z",
    fill: "#37A72E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1137_29262",
    x1: 40.6658,
    y1: 3.21456,
    x2: 57.0068,
    y2: 3.21456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.ef6f7c8d08672e44e8a73829b68e2ecc.svg";
export { ForwardRef as ReactComponent };